
export const FETCH_AUDIT_LOG_BY_USER_REQUEST = 'FETCH_AUDIT_LOG_BY_USER_REQUEST';
export const FETCH_AUDIT_LOG_BY_USER_SUCCESS = 'FETCH_AUDIT_LOG_BY_USER_SUCCESS';
export const FETCH_AUDIT_LOG_BY_USER_FAILURE = 'FETCH_AUDIT_LOG_BY_USER_FAILURE';

export const SET_USER_NAME_AUDIT_TRIAL = 'SET_USER_NAME_AUDIT_TRIAL';

export const CREATE_USER_FORM_AUDIT_TRIAL = 'CREATE_USER_FORM_AUDIT_TRIAL';